import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'

import * as apiAdmin from "../../../api/apiAdmin"
import * as Auth from "../../Login/Auth"
import { ReqPermission, RespPermissionList } from '../../../item/ItemPermission';
import { api_setPermission } from '../../../api/apiPermission';

/**
 * 申請人(下拉選單)
 * @param {*} param0 
 */
export function ManagerSelect({ managerList, setManagerId }) {
  //console.log(managerList)
  return (
    <div className="row">
      <div className="col-sm-2">
        <label className="row pull-right">申請人</label>
      </div>
      <div className="col-sm-4">
        <select className="form-control" onChange={e => setManagerId(e.target.value)}>
          <option value="system">系統</option>
          {
            managerList.map((account, index) => (
              <option key={"account" + index} value={account.accountId}>{account.nickName}</option>
            ))
          }
        </select>
      </div>
    </div>
  )
}
/**
 * 公司(下拉選單)
 * @param {*} param0 
 */
export function CompanySelect({ companyList, setCompanyId }) {
  //console.log(managerList)
  return (
    <div className="row">
      <div className="col-sm-2">
        <label className="row pull-right">公司</label>
      </div>
      <div className="col-sm-4">
        <select className="form-control" onChange={e => setCompanyId(e.target.value)}>
          {
            companyList.map((company, index) => (
              <option key={"company" + index} value={company.companyId}>{company.companyName}</option>
            ))
          }
        </select>
      </div>
    </div>
  )
}

/**
 * 部門(下拉選單)
 * @param {*} param0 
 */
export function DepartmentSelect({ departmentList, setDepartmentId }) {
  //console.log(managerList)
  return (
    <div className="row">
      <div className="col-sm-2">
        <label className="row pull-right">部門</label>
      </div>
      <div className="col-sm-4">
        <select className="form-control" onChange={e => setDepartmentId(e.target.value)}>
          {
            departmentList.map((department, index) => (
              <option key={"company" + index} value={department.departmentId}>{department.departmentName}</option>
            ))
          }
        </select>
      </div>
    </div>
  )
}

/**
 * 角色(下拉選單)
 * @param {*} param0 
 */
export function RoleSelect({ roleList, setRoleId }) {
  return (
    <div className="row">
      <div className="col-sm-2">
        <label className="row pull-right">角色</label>
      </div>
      <div className="col-sm-4">
        <select className="form-control" onChange={e => setRoleId(e.target.value)}>
          {
            roleList.map((role, index) => (
              <option key={"role" + index} value={role.roleId}>{role.roleName}</option>
            ))
          }
        </select>
      </div>
    </div>
  )
}

/**
 * 角色權限
 */
export function RoleItem({ item, roleId, PermissionList }) {
  const [isView, setisView] = useState(false);
  const [isAdd, setisAdd] = useState(false);
  const [isEdit, setisEdit] = useState(false);
  const [isDelete, setisDelete] = useState(false);

  function setCheck() {

    var filterEmpty = PermissionList.filter(function (permission, index, array) {
      return permission.pageId === item.pageId;
    });
    if (filterEmpty.length > 0) {
      //console.log(filterEmpty)
      setisView(filterEmpty[0].isView === 1 ? true : false)
      setisAdd(filterEmpty[0].isAdd === 1 ? true : false)
      setisEdit(filterEmpty[0].isEdit === 1 ? true : false)
      setisDelete(filterEmpty[0].isDelete === 1 ? true : false)
    }
  }

  function setPermission(pageId) {
    //console.log(pageId+","+isView+","+isAdd)
    var mReqPermission = new ReqPermission({
      pageId, roleId, 
      isView: isView?1:0,
      isAdd: isAdd?1:0,
      isEdit: isEdit?1:0,
      isDelete: isDelete?1:0
    })
    var mRespPermissionList = []
    mRespPermissionList.push(mReqPermission)
    api_setPermission({
      mRespPermissionList,
      success: () => {
        Swal.fire({
          type: 'success',
          title: '提醒',
          text: '設定成功',
        })
      },
      failure:()=>{
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: '設定錯誤',
        })
      }
    })
  }

  useEffect(() => {
    setCheck();
  }, []);

  return (

    <>
      <div className="row">
        <div className="col-sm-3">
          {item.pageName}
        </div>
        <div className="col-sm-5 text-info">
          {item.pageLink}
        </div>
        <div className="col-sm-2">
          <label>
            <input type="checkbox" checked={isView} onChange={e => setisView(e.target.checked)} />
            檢視
          </label>
        </div>
        {
          /**
           * 
        <div className="col-md-2">
          <label>
            <input type="checkbox" checked={isAdd} onChange={e => setisAdd(e.target.checked)} />
            新增
          </label>
        </div>
        <div className="col-md-2">
          <label>
            <input type="checkbox" checked={isEdit} onChange={e => setisEdit(e.target.checked)} />
            編輯
          </label>
        </div>
        <div className="col-md-2">
          <label>
            <input type="checkbox" checked={isDelete} onChange={e => setisDelete(e.target.checked)} />
            刪除
          </label>
        </div>
           */
        }
        <div className="col-sm-1">
          <button type="button" className="btn bg-primary  btn-sm" onClick={e => setPermission(item.pageId)}>編輯</button>
        </div>
      </div>
    </>
  )
}